

























































import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import Selector from '@ui/Inputs/Selector'
import sort from  '@utils/sort.coffee'
import TagBar from '@ui/TagBar'

settings =
  name: 'POISelector'

  vue:
    props: ['selectedOptions', 'theme', 'actions', 'options']
    components: { Selector, TagBar }

    data: ->
      poiOptions: []
      distance: 25
      distanceOptions: new Array(25).fill(1).map((v, i) => String(i + 1))

    mounted: ->
      @searchPOIs()
      @initializeDistance()

    computed:
      selectorActions: -> { ...@actions, search: @searchPOIs }

      selectorOptions: ->
        {
          searchBoxPlaceholder: 'Search by name',
          selectOptionsTitle: false,
        }

      normalizedSelectedOptions: ->
        @selectedOptions.map((poi) -> { key: poi.id, ...poi })

      selectedKeys: -> @selectedOptions.map((poi) -> poi.id)

      campaign: -> @options?.campaign || {}
      customPOIs: -> @camapign.custom_pois || []
      customPOIIds: -> @customPOIs.map((customPOI) -> customPOI.id)

      tagBarOptions: ->
        {
          bar: {
            theme: 'selector',
            max: 3,
          },
          tag: {
            theme: 'selector',
            maxLength: 8
          },
          initializeExpanded: false,
        }

      containerWidth: -> document.querySelector('.poi-selector').offsetWidth - 65 || 250

    methods:
      initializeDistance: ->
        @distance = @options.defaultDistance if @options?.defaultDistance?

      searchPOIs: (value = '') ->
        text = value.trim()
        @poiOptions = []
        pois = await RecessAPI.search 'pois', { text, per_page: 100, campaign_id: @campaign.id }

        options = []
        for poi in pois
          options.push({
            key: poi.id,
            value: poi.name,
            type: 'poi_list',
            sortBy: "#{poi.id} #{poi.name} #{poi.slug} #{poi.category_tags?.join(' ')}",
            data: poi
          })
        @poiOptions = options.sort((a, b) -> "#{a.value}".localeCompare("#{b.value}"))

      hiAddCustomPOITrigger: ->
        @actions.addCustomPOI()

      clearSearch: ->
        @$refs.selector.clearSearch()

export default VueOptions.vue settings
